import { render, staticRenderFns } from "./ViewModal.vue?vue&type=template&id=84272b2c"
import script from "./ViewModal.vue?vue&type=script&lang=js"
export * from "./ViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports